import { SidebarProvider } from '@/components/atoms/sidebar';
import { MapSurface } from '@/features/map/components/MapSurface';

/**
 * MapPage — routed entry for the map.
 *
 * Registered once in `src/components/AppRoutes.tsx` as the single `map`
 * route (no path params), so the SAME MapPage element stays mounted whatever
 * card the query names: `?zone=<id>` outlines the zone and opens its card,
 * `?deal=<id>` and `?location=<id>` open theirs. Browser-back or closing a
 * card drops its param.
 *
 * Persistence
 * -----------
 * ONE `MapSurface`/`MapShell` serves every selection. This relies on the
 * route path never changing — two sibling routes would swap the matched
 * element and defeat the persistence.
 *
 * `MapShell` calls `useSidebar()` during render and therefore must live inside a
 * `SidebarProvider`. MapPage is the map surface's composition root, so it owns
 * that provider. The sidebar stays closed: the workspace switcher lives in the
 * navbar and the layer filters in the top bar. Without the provider
 * `useSidebar()` throws synchronously and the app-level ErrorBoundary renders
 * its "Page could not load" fallback.
 *
 * Default export (like the other routed pages) so react-router's registration
 * in `src/components/App.tsx` can default-import it consistently with its siblings.
 */
function MapPage() {
  return (
    <SidebarProvider open={false} disableMobileSheet>
      <MapSurface />
    </SidebarProvider>
  );
}

export default MapPage;
